/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Price_Page_Policy_FreeInputs */

const en_price_page_policy_free = /** @type {(inputs: Price_Page_Policy_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free up to 24 h before the visit`)
};

const pl_price_page_policy_free = /** @type {(inputs: Price_Page_Policy_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bez opłat do 24 h przed wizytą`)
};

/**
* | output |
* | --- |
* | "Free up to 24 h before the visit" |
*
* @param {Price_Page_Policy_FreeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const price_page_policy_free = /** @type {((inputs?: Price_Page_Policy_FreeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Price_Page_Policy_FreeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_price_page_policy_free(inputs)
	return en_price_page_policy_free(inputs)
});